import React, { useMemo } from 'react'
import { ReactComponent as CalendarMoneyIcon } from 'assets/CalendarMoney.svg'
import { useCSDetailsCachedData } from 'components/configured-service/useCSDetailsCachedData'
import { selectBillingStartDate } from 'data/configured-service/configuredServiceDetailsSelectors'
import T from 'T'
import ServiceDetailChip from 'components/configured-service/layout/ServiceDetailChip'

const ServiceBillingStartDateChip = ({ id, ...props }) => {
  const { data = {} } = useCSDetailsCachedData({ id })
  const billingStartDate = useMemo(() => selectBillingStartDate(data), [data])

  return (
    <ServiceDetailChip
      IconComponent={CalendarMoneyIcon}
      label={billingStartDate}
      tooltip={T.BILLING_START_DATE}
      paletteColor="primary"
      paletteVariant="dark"
      {...props}
    />
  )
}

export default ServiceBillingStartDateChip
